<!--横向滑动推荐历史新闻类  view:7-->
<template>
    <div class="view8Wrapper">
        <div class="tipsGlobalText" v-html="tips">
            {{tips}}
        </div>
        <CrossSlip>
            <BaseCard v-for="(item,ix) in list" :imgUrl="item.imgUrl" :name="item.title" :year="item.year"  @on-click="()=>onAsk(item.title,item.title)" :key="`tips-quick-${ix}`" card-type="old" />
        </CrossSlip>
    </div>
</template>


<script>
    import CrossSlip from '../Use/cross-slip-wrapper'
    import BaseCard from '../Use/base-card'
    import {mapState, mapActions, mapMutations} from "vuex";
    export default {
        name: 'View8',
        components: {
            CrossSlip,BaseCard
        },
        props: {
            list: {
                type: Array,
                default: []
            },
            tips:{
                type: String,
                default: ''
            },
        },
        data () {
            return {

            }

        },
        methods: {
            onRouter(path) {
                // this.$emit('on-router',path)
            }


        }
    }
</script>
<style lang="less" scoped>
    .view8Wrapper{

    }

</style>
